$(document).ready(function(){
  $('.featured-products__slider').slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<div class="arrow-right"><img src="//www.karsnuts.com/cdn/shop/t/4/assets/circle-chevron-right-solid.png?v=59075128112754349931735033472" alt="previous"></div>',
    prevArrow: '<div class="arrow-left"><img src="//www.karsnuts.com/cdn/shop/t/4/assets/circle-chevron-left-solid.png?v=136044634091647694061735033487" alt="next"></div>'
  });

  $(".featured-products__thumbnail").click(function(){
    $(".featured-products__thumbnail").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    var color = $(this).data("color");
    var section = $(this).data("section");
    $('.featured-products__slider').slick('slickGoTo', i);
    $('#section-'+section).css('background', color);
    $('#section-'+section+' .featured-products__button span').css('color', color);
  });

  $('.featured-products__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".featured-products__thumbnail").removeClass("active");
        $(".featured-products__thumbnail[data-index='"+nextSlide+"']").addClass("active");
        var color = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("color");
        var section = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("section");
        $('#section-'+section).css('background', color);
        $('#section-'+section+' .featured-products__button span').css('color', color);

    $(".featured-products__slide-sticker .sticker").hide();
    $(".featured-products__slide-sticker .sticker[data-index='"+nextSlide+"']").show();
  });

  $(".pronunciation .play-audio").click(function(){
    $(this).parent().find("#sahale-pronunciation-audio")[0].play();
  });

  $(".richtext-section .rt-pronunciation .play-audio").click(function(){
    $(this).parent().find("#richtext-audio")[0].play();
  });

  $('.hero__arrow-left').click(function(){
    $('.hero[data-arrows=true] .flickity-previous').trigger('click');
  });
  $('.hero__arrow-right').click(function(){
    $('.hero[data-arrows=true] .flickity-next').trigger('click');
  });

  $('header .site-nav > li').mouseover(function(){
    $(this).find('details').attr('open', true)
  });
  $('header .site-nav > li').mouseout(function(){
    $(this).find('details').removeAttr('open')
  });

  $('.our-story__control .close-all').click(function(){
    $('.our-story__control .open-all').removeClass('active');
    $(this).addClass('active');
    $('.our-story__row').removeClass('open');
  });
  $('.our-story__control .open-all').click(function(){
    $('.our-story__control .close-all').removeClass('active');
    $(this).addClass('active');
    $('.our-story__row').addClass('open');
  });
  $('.our-story__row .row-header').click(function(){
    if($(this).parent().hasClass('open')){
      $(this).parent().removeClass('open');
    }else{
      $(this).parent().addClass('open');
    }
  });

  

  
});

window.onload = function() {
    var options = document.querySelectorAll('option[value="created-ascending"], option[value="created-descending"]');
    options.forEach(function(option) {
        option.remove();
    });
};